<template>
  <v-card class="pa-2 mt-3" outlined flat>
    <v-form>
      <v-container>
        <v-row>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="items.individualName"
              label="Individual"
              :outlined="outlined"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="items.caseNo"
              label="Case #"
              :outlined="outlined"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-select
              v-model="items.provider"
              label="Provider Name"
              :outlined="outlined"
              :items="providers"
              item-text="Provider.Name"
              item-value="Provider.Name"
            ></v-select>
          </v-col>
          <v-col cols="12" md="6">
            <v-row>
              <v-col cols="12" md="12">
                <div class="d-flex">
                  <span class="align-self-center">Provider JDT Location</span>
                  <span class="ml-4">
                    <div class="d-flex align-center">
                      <v-radio-group v-model="items.rbgUrban" row>
                        <v-radio label="Urban" value="true"></v-radio>
                        <v-radio label="Rural" value="false"></v-radio>
                      </v-radio-group>
                    </div>
                  </span>
                </div>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="items.serviceMonth"
              label="Month of Service"
              :outlined="outlined"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="items.serviceYear"
              label="Year of Service"
              :outlined="outlined"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-sheet elevation="1" class="pa-5">
              <table>
                <thead>
                  <tr height="50px">
                    <td>
                      <div class="text-center text-body-2 font-weight-bold">
                        Staff Initial
                      </div>
                    </td>
                    <td>
                      <div class="text-center text-body-2 font-weight-bold">
                        Staff Printed Name
                      </div>
                    </td>

                    <td v-if="items.staffs.length > 1" width="5%">
                      <div class="text-center text-body-2 font-weight-bold">
                        Action
                      </div>
                    </td>
                  </tr>
                </thead>

                <tbody>
                  <tr v-for="(item, i) in items.staffs" :key="i">
                    <td class="text-center">
                      <div class="pa-2">
                        <v-text-field
                          v-model="item.staffInitial"
                          :outlined="outlined"
                          dense
                          hide-details
                        ></v-text-field>
                      </div>
                    </td>
                    <td class="text-center">
                      <div class="pa-2">
                        <v-text-field
                          v-model="item.staffName"
                          :outlined="outlined"
                          dense
                          hide-details
                        ></v-text-field>
                      </div>
                    </td>

                    <td v-if="items.staffs.length > 1" class="text-center">
                      <div class="pa-2">
                        <v-btn
                          color="error"
                          dark
                          right
                          class=""
                          @click="removeStaff(i)"
                        >
                          <v-icon>mdi-delete</v-icon>
                        </v-btn>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>

              <div class="d-flex justify-end mt-5">
                <v-btn
                  color="warning"
                  dark
                  right
                  class=""
                  @click="clearStaffItems"
                >
                  clear
                </v-btn>
                <div class="ma-1"></div>
                <v-btn color="primary" dark right class="" @click="addStaff">
                  add
                </v-btn>
              </div>
            </v-sheet>
          </v-col>
        </v-row>

        <v-row>
          <v-col
            cols="12"
            class="white--text text-uppercase text-center text-caption"
            style="background-color: #2b3990"
            >Document Hours in Attendance for each service.
          </v-col>
          <v-col cols="12">
            <v-row>
              <v-col>
                <ul>
                  <li>Entries must be in date order</li>
                  <li>One Service Type Per entry</li>
                </ul>
              </v-col>
              <v-col>
                <ul>
                  <li>Enter AM and PM for all start and end times.</li>
                  <li>Round to the nearest ¼ hour (.25)</li>
                </ul>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12">
            <v-sheet elevation="1" class="pa-5">
              <table>
                <thead>
                  <tr>
                    <td rowspan="2">
                      <div class="text-center text-body-2 font-weight-bold">
                        Date <br />
                        XX/XX/20XX
                      </div>
                    </td>
                    <td rowspan="2">
                      <div class="text-center text-body-2 font-weight-bold">
                        Start Time <br />
                        00:00 <br />
                        AM/PM
                      </div>
                    </td>
                    <td rowspan="2">
                      <div class="text-center text-body-2 font-weight-bold">
                        End Time <br />
                        00:00 <br />
                        AM/PM
                      </div>
                    </td>
                    <td rowspan="2">
                      <div class="text-center text-body-2 font-weight-bold">
                        Total Hours
                      </div>
                    </td>
                    <td colspan="4">
                      <div class="text-center text-body-2 font-weight-bold">
                        Check Service Type Provided:
                      </div>
                    </td>
                    <td rowspan="2">
                      <div class="text-center text-body-2 font-weight-bold">
                        Approved Ratio
                      </div>
                    </td>
                    <td rowspan="2">
                      <div class="text-center text-body-2 font-weight-bold">
                        Staff Initials
                      </div>
                    </td>
                    <td rowspan="2">
                      <div class="text-center text-body-2 font-weight-bold">
                        Individual Initials
                      </div>
                    </td>
                    <td v-if="items.timesheets.length > 1" rowspan="2">
                      <div class="text-center text-body-2 font-weight-bold">
                        Actions
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td width="5%">
                      <div class="text-center text-caption">
                        Day Habilitation <br />
                        T2021
                      </div>
                    </td>
                    <td width="5%">
                      <div class="text-center text-caption">
                        Pre Vocational <br />
                        T2047
                      </div>
                    </td>
                    <td width="5%">
                      <div class="text-center text-caption">
                        Supported Employment <br />
                        T2019
                      </div>
                    </td>
                    <td width="5%">
                      <div class="text-center text-caption">
                        Career Planning <br />
                        T2019
                      </div>
                    </td>
                  </tr>
                </thead>

                <tbody>
                  <tr v-for="(item, i) in items.timesheets" :key="i">
                    <td class="text-center">
                      <div class="pa-2">
                        <v-text-field
                          v-model="item.date"
                          :outlined="outlined"
                          dense
                          hide-details
                        ></v-text-field>
                      </div>
                    </td>
                    <td class="text-center">
                      <div class="pa-2">
                        <v-text-field
                          v-model="item.start"
                          :outlined="outlined"
                          dense
                          hide-details
                        ></v-text-field>
                      </div>
                    </td>
                    <td class="text-center">
                      <div class="pa-2">
                        <v-text-field
                          v-model="item.end"
                          :outlined="outlined"
                          dense
                          hide-details
                        ></v-text-field>
                      </div>
                    </td>
                    <td class="text-center">
                      <div class="pa-2">
                        <v-text-field
                          v-model="item.totalHours"
                          :outlined="outlined"
                          dense
                          hide-details
                        ></v-text-field>
                      </div>
                    </td>
                    <td class="text-center">
                      <div class="d-flex pa-2 align-center chk">
                        <v-checkbox
                          v-model="item.chkDayHabilitation"
                        ></v-checkbox>
                      </div>
                    </td>
                    <td class="text-center">
                      <div class="d-flex pa-2 align-center chk">
                        <v-checkbox
                          v-model="item.chkPreVocational"
                        ></v-checkbox>
                      </div>
                    </td>
                    <td class="text-center">
                      <div class="d-flex pa-2 align-center chk">
                        <v-checkbox
                          v-model="item.chkSupportedEmployment"
                        ></v-checkbox>
                      </div>
                    </td>
                    <td class="text-center">
                      <div class="d-flex pa-2 align-center chk">
                        <v-checkbox
                          v-model="item.chkCareerPlanning"
                        ></v-checkbox>
                      </div>
                    </td>
                    <td class="text-center">
                      <div class="pa-2">
                        <v-text-field
                          v-model="item.approvedRatio"
                          :outlined="outlined"
                          dense
                          hide-details
                        ></v-text-field>
                      </div>
                    </td>
                    <td class="text-center">
                      <div class="pa-2">
                        <v-text-field
                          v-model="item.staffInitials"
                          :outlined="outlined"
                          dense
                          hide-details
                        ></v-text-field>
                      </div>
                    </td>
                    <td class="text-center">
                      <div class="pa-2">
                        <v-text-field
                          v-model="item.individualInitials"
                          :outlined="outlined"
                          dense
                          hide-details
                        ></v-text-field>
                      </div>
                    </td>

                    <td v-if="items.timesheets.length > 1" class="text-center">
                      <div class="pa-2">
                        <v-btn
                          color="error"
                          dark
                          right
                          class=""
                          @click="removeTimesheet(i)"
                        >
                          <v-icon>mdi-delete</v-icon>
                        </v-btn>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>

              <div class="d-flex justify-end mt-5">
                <v-btn
                  color="warning"
                  dark
                  right
                  class=""
                  @click="clearTimesheetItems"
                >
                  clear
                </v-btn>
                <div class="ma-1"></div>
                <v-btn
                  color="primary"
                  dark
                  right
                  class=""
                  @click="addTimesheet"
                >
                  add
                </v-btn>
              </div>
            </v-sheet>
          </v-col>
        </v-row>
      </v-container>
    </v-form>
  </v-card>
</template>
<script>
/*eslint-disable */
export default {
  props: {
    items: Object,
    providers: {
      type: Array,
    }
  },
  data() {
    return {
      outlined: true,
      // items: {
      //   timesheets: [{}],
      //   staffs: [{}],
      // },
    };
  },
  methods: {
    getItems() {
      return this.items;
    },

    getData() {
      return this.flattenArrays({
        ...this.items,
        ...this.timesheetCalculatedHours(),
      });
    },

    addTimesheet() {
      this.items.timesheets.push({});
    },

    removeTimesheet(i) {
      this.items.timesheets.splice(i, 1);
    },

    addStaff() {
      this.items.staffs.push({});
    },

    removeStaff(i) {
      this.items.staffs.splice(i, 1);
    },

    clearTimesheetItems() {
      this.items.timesheets = [{}];
    },

    clearStaffItems() {
      this.items.staffs = [{}];
    },

    flattenArrays(data) {
      const flattened = {};

      Object.entries(data).forEach(([key, value]) => {
        if (!Array.isArray(value)) {
          flattened[key] = value;
        } else {
          value.forEach((item, index) => {
            Object.entries(item).forEach(([innerKey, innerValue]) => {
              flattened[`${innerKey}${index + 1}`] = innerValue;
            });
          });
        }
      });

      return flattened;
    },

    timesheetCalculatedHours() {
      const timesheetLength = this.items.timesheets.length;
      const pageBreaks = [0, 12, 30];

      const totals = {
        totalHours: this.timesheetsPage(
          pageBreaks,
          timesheetLength,
          "totalHours"
        )[0],
        totalDay: this.timesheetsPage(
          pageBreaks,
          timesheetLength,
          "chkDayHabilitation"
        )[0],
        totalPre: this.timesheetsPage(
          pageBreaks,
          timesheetLength,
          "chkPreVocational"
        )[0],
        totalSupported: this.timesheetsPage(
          pageBreaks,
          timesheetLength,
          "chkSupportedEmployment"
        )[0],
        totalCareer: this.timesheetsPage(
          pageBreaks,
          timesheetLength,
          "chkCareerPlanning"
        )[0],
        currentTotalHours: this.timesheetsPage(
          pageBreaks,
          timesheetLength,
          "currentTotalHours"
        )[1],
        currentDay: this.timesheetsPage(
          pageBreaks,
          timesheetLength,
          "chkDayHabilitation"
        )[1],
        currentPre: this.timesheetsPage(
          pageBreaks,
          timesheetLength,
          "chkPreVocational"
        )[1],
        currentSupported: this.timesheetsPage(
          pageBreaks,
          timesheetLength,
          "chkSupportedEmployment"
        )[1],
        currentCareer: this.timesheetsPage(
          pageBreaks,
          timesheetLength,
          "chkCareerPlanning"
        )[1],
      };

      totals.previousTotalHour = totals.totalHours;
      totals.previousDay = totals.totalDay;
      totals.previousPre = totals.totalPre;
      totals.previousSupported = totals.totalSupported;
      totals.previousCareer = totals.totalCareer;

      totals.currentDay = totals.currentDay;
      totals.currentPre = totals.currentPre;
      totals.currentSupported = totals.currentSupported;
      totals.currentCareer = totals.currentCareer;

      totals.monthTotal = totals.currentTotalHours + totals.previousTotalHour;
      totals.overallTotalDay = totals.currentDay + totals.previousDay;
      totals.overallTotalPre = totals.currentPre + totals.previousPre;
      totals.overallTotalSupported =
        totals.currentSupported + totals.previousSupported;
      totals.overallTotalCareer = totals.currentCareer + totals.previousCareer;

      Object.keys(totals).forEach((key) => {
        totals[key] = totals[key].toString();
      });

      return totals;
    },

    timesheetsPage(pageBreaks, timesheetLength, hourToCalculate) {
      return pageBreaks.map((breakPoint, index, array) =>
        index < array.length - 1
          ? this.calculateTotalHours(
              breakPoint,
              Math.min(array[index + 1], timesheetLength),
              hourToCalculate
            )
          : 0
      );
    },

    calculateTotalHours(startIndex, limit, hourToCalculate) {
      return this.items.timesheets
        .slice(startIndex, limit)
        .reduce((total, timesheet) => {
          const hours = parseInt(timesheet.totalHours, 10) || 0;
          if (hourToCalculate === "totalHours") {
            return total + hours;
          } else if (hourToCalculate === "currentTotalHours") {
            return total + hours;
          } else if (timesheet[hourToCalculate]) {
            return total + hours;
          }
          return total;
        }, 0);
    },
  },
};
</script>

<style scoped>
h1 {
  font-size: 1.5rem;
  font-weight: 400;
}

.fab--btn {
  display: "absolute";
  bottom: 10px;
}

.fab--btn.delete {
  right: calc(-100% + 20px);
}

.fab--btn.delete.custome {
  right: calc(-100% + -10px);
  top: 40px;
}

/* table design */
table {
  border-collapse: collapse !important;
}

table,
th,
td {
  border: 1px solid;
}

table {
  width: 100%;
}

.chk {
  /* background-color: red; */
  justify-content: center;
  margin: -10px;
}
</style>
